import { Group } from '../group/group';

export class Role {
  id: string | undefined;
  label: string | undefined;
  name: string | undefined;
  isInherited: boolean | undefined;
  inheritedFrom: [Group];

  constructor(payload?: any) {
    if (payload) {
      this.label = payload.label;
      this.name = payload.name;
      this.id = payload.name;
      this.isInherited = payload.isInherited;
      if(payload.inheritedFrom) {
        this.inheritedFrom = payload.inheritedFrom.map((group: any) => new Group(group));
      }
    }
  }

  static createRoles(result: Array<any>): Role[] {
    const roles = new Array<Role>();
    if (result) {
      result.map((role) => {
        roles.push(new Role(role));
      });
    }
    return roles;
  }
}
